                                    
const config = {
    http: {
        //baseUrl: 'http://vuedev.appnext.com', // if not set, the http base url will be the current used domain
        real: true, // in production, set to true
        log: true // in test mode (real=false), set if to log the http requests and responses to the console
    },
    enableRouting: false
};

export default config;



// WEBPACK FOOTER //
// ./src/appConfig.config.js